const generateTicketNumber = (): string => {
	const now = new Date();
	return `T-${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now
		.getDate()
		.toString()
		.padStart(2, '0')}-${Math.floor(Math.random() * 10000)}`;
};

export default generateTicketNumber;
